module.exports = __webpack_public_path__ + "media/images/icons/grey-v-dots-1cab863ffa60b26b5c355f64c8a3c06d.svg";